//This file is used for maintain JavaScript functions that are bound to a particular scope or view
(function (module) {
  'use strict';
  module
    .controller('allowIntegrationsController', ['$scope', 'authService', 'agencySelectService', 'clientSelectService', '$sce', 'allowIntegrations', 'apps', '$stateParams', 'progressBar', 'ngDialog',
      'uiGridConstants', '$state',
      function ($scope, authService, agencySelectService, clientSelectService, $sce, allowIntegrations, apps, $stateParams, progressBar, ngDialog, uiGridConstants, $state) {
        const progress = progressBar.getProgressBar();
        $scope.allowIntegration = {
          Id: 0,
          CategoryApp: null,
          OrganizationId: null,
          Allowed: false
        };
        $scope.isEdit = false;
        $scope.userRole = authService.getLoginMember().Role;
        apps.getApps().then(function (response) {
          const arr1 = response.data;
          arr1.sort((a, b) => a.CategoryName.localeCompare(b.CategoryName));
          $scope.apps = arr1;
        });

        const id = $stateParams.id;
        if ((!!id)) {
          allowIntegrationDetailsById(id);
        }

        $scope.clientId = clientSelectService.getSelectedClient().id;
        $scope.appId = 0;
        // Validate that filtered organization id is defined
        function validateOrganization() {
          const organization = clientSelectService.getSelectedClient();
          return organization.id != null && Number.isInteger(organization.id);
        }

        function allowIntegrationDetailsById(id) {
          progress.start();
          allowIntegrations.getAllowIntegrationById(id).then(function (response) {
            $scope.isEdit = true;
            const AllowIntegrationContext = response.data;
            bindAllowIntegration(AllowIntegrationContext[0]);
          });
        };

        function bindAllowIntegration(AllowIntegrationContext) {
          if (!!AllowIntegrationContext) {
            $scope.appId = AllowIntegrationContext.CategoryApp;
            $scope.allowIntegration.Id = AllowIntegrationContext.Id;
            $scope.allowIntegration.OrganizationId = AllowIntegrationContext.OrganizationId;
            $scope.allowIntegration.Name = AllowIntegrationContext.Name;
            $scope.allowIntegration.Category = AllowIntegrationContext.Category;
            $scope.allowIntegration.Allowed = AllowIntegrationContext.Allowed;
          }
        };

        $scope.saveAllowIntegration = function () {
          const clientId = clientSelectService.getSelectedClient().id;
          if ($scope.allowIntegrationForm.$valid && !!clientId) {
            let allowIntegrationData = $scope.allowIntegration;
            allowIntegrationData.OrganizationId = clientId;
            allowIntegrationData.CategoryApp = $scope.appId;
            const promisePost = allowIntegrations.addAllowIntegration(allowIntegrationData);

            progress.start();
            promisePost.then(function (allowIntegrationData) {
              const dialogPost = ngDialog.open({
                template: 'templates/partials/viewSuccessMsg.html',
                className: 'ngdialog-theme-plain',
                controller: ['$scope', function ($scope) {
                  $scope.successMsg = "Integration added successfully.";
                  $scope.strTitle = 'Add Allow Integration Success';
                },],
              });
              dialogPost.closePromise.then(function (data) {
                $scope.clearAll();
                $state.go('app.allowIntegrations');
              });

            }, function (err) {
              console.log("eeee",err);
              if (err.status != 401) {
                ngDialog.open({
                  template: 'templates/partials/viewErrorMsg.html',
                  className: 'ngdialog-theme-plain',
                  controller: ['$scope', function ($scope) {
                    $scope.errMsg = err.statusText  + ' ' + err.data;
                    $scope.errTitle = 'Add Allow Integration Error';
                  },],
                });
              }
            })
              .finally(function () {
                progress.complete();
              });
          } else {
            ngDialog.open({
              template: 'templates/partials/viewErrorMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.errMsg = "Please enter all required fields.";
                $scope.errTitle = 'Allow Integration Error';
              },],
            });
          }
        };
        $scope.updateAllowIntegration = function () {
          const clientId = clientSelectService.getSelectedClient().id;
          if ($scope.allowIntegrationForm.$valid && !!clientId) {
            let allowIntegrationData = $scope.allowIntegration;
            allowIntegrationData.OrganizationId = clientId;
            allowIntegrationData.CategoryApp = $scope.appId;
            progress.start();
            const promisePut = allowIntegrations.updateAllowIntegration(allowIntegrationData.Id, allowIntegrationData);
            promisePut.then(function () {
              const dialogPut = ngDialog.open({
                template: 'templates/partials/viewSuccessMsg.html',
                className: 'ngdialog-theme-plain',
                controller: ['$scope', function ($scope) {
                  $scope.successMsg = "Integration updated successfully.";
                  $scope.strTitle = 'Update Allow Integration Success';
                },],
              });
              dialogPut.closePromise.then(function (data) {
                $state.go('app.allowIntegrations');
              });
            }, function (err) {
              if (err.status != 401) {
                ngDialog.open({
                  template: 'templates/partials/viewErrorMsg.html',
                  className: 'ngdialog-theme-plain',
                  controller: ['$scope', function ($scope) {
                    $scope.errMsg = err.statusText + ' ' + err.data;
                    $scope.errTitle = 'Update Allow Integration Error';
                  },],
                });
              }
            })
              .finally(function () {
                progress.complete();
              });
          } else {
            ngDialog.open({
              template: 'templates/partials/viewErrorMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.errMsg = "Please enter all required fields.";
                $scope.errTitle = 'Allow Integration Required Message';
              },],
            });
          }
        };
        $scope.clearAll = function () {
          $scope.allowIntegration = {};
          $scope.isEdit = false;
          $scope.clientId = null;
          $scope.appId = null;
          $scope.allowIntegrationForm.$setPristine();
        };

        // ui-grid code
        const paginationOptions = {
          pageNumber: 1,
          pageSize: 25,
          sort: null,
        };
        $scope.gridOptions = {
          paginationPageSizes: [5, 10, 25, 50],
          enableFiltering: true,
          enableGridMenu: false,
          paginationPageSize: 25,
          useExternalPagination: true,
          useExternalSorting: false,
          enableColumnResizing: true,
          enableRowSelection: true,
          enableSelectAll: false,
          enableRowHeaderSelection: false,
          multiSelect: false,
          columnDefs: [{
            name: 'Name',
            visible: true,
            enableHiding: false,
            displayName: 'Name',
            enableSorting: true,
            sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
            enableFiltering: true,
            enableColumnResizing: true,
            maxWidth: 250,
            sort: {
              direction: uiGridConstants.ASC,
              priority: 0,
            },
          }, {
            name: 'Category',
            visible: true,
            displayName: 'Category',
            enableHiding: false,
            enableSorting: true,
            sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
            enableFiltering: true,
            enableColumnResizing: true,
            maxWidth: 250,
          }, {
            name: 'Allowed',
            displayName: 'Allowed',
            visible: true,
            enableSorting: false,
            sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
            maxWidth: 250,
            enableColumnResizing: true,
            cellTemplate: ' <span ng-show="row.entity.Allowed" style="padding-left: 5px;">Yes</span> <span ng-hide="row.entity.Allowed" style="padding-left: 5px;">No</span>',
            filter: {
              type: uiGridConstants.filter.SELECT,
              selectOptions: [{
                value: 'true',
                label: 'Yes',
              }, {
                value: 'false',
                label: 'No',
              },],
            },
          }],
          onRegisterApi: function (gridApi) {
            $scope.gridApi = gridApi;
            $scope.gridApi.core.on.sortChanged($scope, function (grid, sortColumns) {
              if (!sortColumns.length) {
                paginationOptions.sort = null;
              } else {
                paginationOptions.sort = sortColumns[0].sort.direction;
              }
            });
            gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
              paginationOptions.pageNumber = newPage;
              paginationOptions.pageSize = pageSize;
              setGridData();
            });
            // Show organization details on grid row selection.
            gridApi.selection.on.rowSelectionChanged($scope, function (row) {
              $scope.rowSelectingId = row.entity.Id;
              if (row.isSelected) {
                $scope.rowSelecting = true;
              } else {
                $scope.rowSelecting = false;
              }
            });
          },
        };
        // Validate that filtered organization id is defined
        function validateAgencyAndClientSelection() {
          const agency = agencySelectService.getSelectedAgency();
          const client = clientSelectService.getSelectedClient();
          return {
            agencyValid: agency.id != null && Number.isInteger(agency.id),
            clientValid: client.id != null && Number.isInteger(client.id),
          };
        }

        function setGridData() {
          const valid = validateAgencyAndClientSelection();
          if (valid.agencyValid && valid.clientValid) {
            const selectedClientId = clientSelectService.getSelectedClient().id;
            if (!!selectedClientId) {
              getAllowIntegrations(selectedClientId);
            }
          }
        };

        function getAllowIntegrations(clientId) {
          progress.start();
          allowIntegrations.getAllowIntegrationsByOrganizationId(clientId).then(function (response) {
            const allowIntegration = response.data;
            const firstRow = (paginationOptions.pageNumber - 1) * paginationOptions.pageSize;
            $scope.gridOptions.data = allowIntegration.slice(firstRow, firstRow + paginationOptions.pageSize);
            $scope.gridOptions.totalItems = allowIntegration.length;            
          }).finally(function () {
              progress.complete();
          });
        }
        setGridData();

        $scope.view = function () {
          if (!!$scope.rowSelectingId) {
            allowIntegrationDetailsById($scope.rowSelectingId);
          }
          ngDialog.open({
            template: 'templates/partials/viewAllowIntegration.html',
            className: 'ngdialog-theme-plain',
            scope: $scope,
          });
        };
        $scope.deleteAllowIntegration = function () {
          const confirm = ngDialog.open({
            template: 'templates/partials/viewConfirm.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) { 
              $scope.strTitle = 'Delete Allow Integration?';
              $scope.strMsg = 'Do you really want to delete this allow integration?';
            },],
          });
          confirm.closePromise.then(function (data) {
            if ($scope.rowSelectingId && data.value === 1) {
              progress.start();
              allowIntegrations.deleteAllowIntegration($scope.rowSelectingId).then(function (response) {
                const dialog = ngDialog.open({
                  template: 'templates/partials/viewSuccessMsg.html',
                  className: 'ngdialog-theme-plain',
                  controller: ['$scope', function ($scope) { 
                    $scope.successMsg = 'The allow integration has been succesfully deleted.';
                    $scope.strTitle = 'Delete Allow Integration Success';
                  },],
                });
                dialog.closePromise.then(function (data) { });
              }, function (err) {
                if (err.status != 401) {
                  const dialog = ngDialog.open({
                    template: 'templates/partials/viewErrorMsg.html',
                    className: 'ngdialog-theme-plain',
                    controller: ['$scope', function ($scope) {
                      $scope.errMsg = err.statusText + ' ' + err.data;
                      $scope.errTitle = 'Delete Allow Integration Error';
                    },],
                  });
                  dialog.closePromise.then(function (data) { });
                }
              })
                .finally(function () {
                  progress.complete();
                  setGridData();
                });
            }
          });
        };
        $scope.edit = function () {
          $state.go('app.editAllowIntegration', {
            id: $scope.rowSelectingId,
          });
        };
        // Watch clientSelectService for changes to getFilteredOrganization() output -- expensive, calls getFilteredOrganization many times during $digest cycle
        $scope.$watch(function () {
          return clientSelectService.getSelectedClient();
        }, function (newValue, oldValue) {
          if (newValue !== oldValue) {
            $scope.clientId = null;
            $scope.gridOptions.data = [];
            $scope.gridOptions.totalItems = 0;
            setGridData();
          }
        }, true);
      },
    ]);
})(angular.module('obex'));


// WEBPACK FOOTER //
// ./client/js/controllers/allowIntegrationsController.js